var map = {
	"./bg/strings.json": 1970,
	"./cs/strings.json": 1971,
	"./da/strings.json": 1972,
	"./de/strings.json": 1973,
	"./el/strings.json": 1974,
	"./es-ES/strings.json": 1975,
	"./es-LA/strings.json": 1976,
	"./et/strings.json": 1977,
	"./fi/strings.json": 1978,
	"./fr-CA/strings.json": 1979,
	"./fr/strings.json": 1980,
	"./it/strings.json": 1981,
	"./lt/strings.json": 1982,
	"./lv/strings.json": 1983,
	"./nl/strings.json": 1984,
	"./no/strings.json": 1985,
	"./pl/strings.json": 1986,
	"./pseudo/strings.json": 1987,
	"./pt/strings.json": 1988,
	"./ro/strings.json": 1989,
	"./sk/strings.json": 1990,
	"./sl/strings.json": 1991,
	"./sv/strings.json": 1992,
	"./zh-CN/strings.json": 1993,
	"./zh-TW/strings.json": 1994
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1969;